import { fromJS } from 'immutable';
import { GET_OFFER_SUCCESS } from './actions';
export const OFFER_API_DATA = 'offerProductData';
export const initialState = fromJS({
  loading: false
});

const offerReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_OFFER_SUCCESS:
      return state.set(OFFER_API_DATA, {
        product: action.payload.data.offers[0].product,
        id: action.payload.data.offers[0].id,
        features: action.payload.data.offers[0].features
      });
    default:
      return state;
  }
};

export default offerReducer;
